import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { accountService, alertService } from '../../_services';
import config from '../../_helpers/config';

const API_URL = config.AUTH_API_SERVER;

const permissions = {
  'Digital Signage': ['Screens', 'Playlist', 'Templates', 'Schedules', 'Reports', 'Media'],
  'Restaurant Solution': ['Variety', 'Category','POS','Tables','Member','Customer','Kitchen','QR Codes','Notification','Promotion','Apps', 'Items', 'Inventory', 'Orders', 'Reports','Digital Signage'],
};

const actions = ['View', 'Create', 'Edit', 'Delete'];

const CustomCheckbox = ({ checked, onChange, size = 32 }) => (
  <span 
    onClick={onChange}
    style={{
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: '4px',
      backgroundColor: checked ? '#3b82f6' : 'white',
      border: `2px solid ${checked ? '#3b82f6' : '#d1d5db'}`,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      margin: '0 auto'
    }}
  >
    {checked && (
      <svg width={size * 0.6} height={size * 0.6} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M5 12L10 17L19 8" 
          stroke="white" 
          strokeWidth="3" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    )}
  </span>
);

const AddRolePermissionPopup = ({ roleData, onSave, onClose, user }) => {

  const [roleName, setRoleName] = useState(roleData ? roleData.roleName : "");
  const [permissionState, setPermissionState] = useState(roleData ? initializePermissions(roleData) : {});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
   let loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  useEffect(() => {
    const initialCollapsed = {};
    Object.keys(permissions).forEach(module => {
      initialCollapsed[module] = false;
    });
  }, []);

   useEffect(() => {
    setRoleName(roleData ? roleData.roleName : "");
    setPermissionState(roleData ? initializePermissions(roleData) : {});

  }, [roleData]);
  
   function initializePermissions(roleData) {
    if (!roleData || !roleData.permissions) return {};
    
    try {
      let initialPermissions = {};
      const perms = typeof roleData.permissions === 'string' ? 
        JSON.parse(roleData.permissions) : roleData.permissions;
      
      Object.entries(permissions).forEach(([module, items]) => {
        items.forEach(item => {
          actions.forEach(action => {
            const key = `${module}-${item}-${action}`;
            initialPermissions[key] = false;
          });
        });
      });
      
      Object.entries(perms).forEach(([key, value]) => {
        if (value === true) {
          const cleanKey = key.replace(/^IS_/, '');
          let itemName = '';
          let actionType = '';
          
          if (cleanKey.endsWith('_VIEW') || cleanKey.endsWith('_READ')) {
            actionType = 'View';
            itemName = cleanKey.replace(/_VIEW$|_READ$/, '');
          } else if (cleanKey.endsWith('_CREATE') || cleanKey.endsWith('_ADD')) {
            actionType = 'Create';
            itemName = cleanKey.replace(/_CREATE$|_ADD$/, '');
          } else if (cleanKey.endsWith('_EDIT')) {
            actionType = 'Edit';
            itemName = cleanKey.replace(/_EDIT$/, '');
          } else if (cleanKey.endsWith('_DELETE')) {
            actionType = 'Delete';
            itemName = cleanKey.replace(/_DELETE$/, '');
          }
          
          for (const [module, items] of Object.entries(permissions)) {
            const matchedItem = items.find(item => 
              itemName === item.toUpperCase() || 
              (itemName === 'SCREENS' && item === 'Screens') ||
              (itemName === 'PLAYLIST' && item === 'Playlist') ||
              (itemName === 'CATEGORY' && item === 'Category') ||
              (itemName === 'ITEMS' && item === 'Items')
            );
            
            if (matchedItem) {
              const permKey = `${module}-${matchedItem}-${actionType}`;
              initialPermissions[permKey] = true;
              break;
            }
          }
        }
      });
      
      Object.entries(permissions).forEach(([module, items]) => {
        items.forEach(item => {
          actions.forEach(action => {
            const key = `${module}-${item}-${action}`;
            
            if (module === 'Digital Signage' && item === 'Screens') {
              if (action === 'View' && perms.IS_SCREENS_VIEW) initialPermissions[key] = true;
              if (action === 'Create' && perms.IS_SCREENS_CREATE) initialPermissions[key] = true;
              if (action === 'Edit' && perms.IS_SCREENS_EDIT) initialPermissions[key] = true; 
              if (action === 'Delete' && perms.IS_SCREENS_DELETE) initialPermissions[key] = true;
            }
            else if (module === 'Restaurant Solution' && item === 'Items') {
              if (action === 'View' && perms.IS_ITEMS_VIEW) initialPermissions[key] = true;
              if (action === 'Create' && perms.IS_ITEMS_CREATE) initialPermissions[key] = true;
              if (action === 'Edit' && perms.IS_ITEMS_EDIT) initialPermissions[key] = true;
              if (action === 'Delete' && perms.IS_ITEMS_DELETE) initialPermissions[key] = true;
            }
          });
        });
      });
      
      return initialPermissions;
    } catch (error) {
      console.error("Error parsing permissions:", error);
      return {};
    }
  }

  function handleClose() {
    if (typeof onClose === 'function') {
      console.log("Calling parent onClose function");
      setRoleName("");
      onClose();
    } 
  }

  
 

  const handleCheckboxChange = (module, item, action) => {
    setPermissionState(prev => {
      const key = `${module}-${item}-${action}`;
      const newValue = !prev[key];
      const updates = { [key]: newValue };
      
      if (newValue && (action === 'Create' || action === 'Edit' || action === 'Delete')) {
        const viewKey = `${module}-${item}-View`;
        updates[viewKey] = true;
      }
      
      if (!newValue && action === 'View') {
        const createKey = `${module}-${item}-Create`;
        const editKey = `${module}-${item}-Edit`;
        const deleteKey = `${module}-${item}-Delete`;
        updates[createKey] = false;
        updates[editKey] = false;
        updates[deleteKey] = false;
      }
      
      return {
        ...prev,
        ...updates
      };
    });
  };


  const handleSave = async () => {
    if (!roleName.trim()) {
      alertService.error("Please enter a role name");
      return;
    }

    setIsSubmitting(true);
    setError(null);

    const permissionsObj = {};
    
    Object.entries(permissions).forEach(([module, items]) => {
      items.forEach(item => {
        actions.forEach(action => {
          const isEnabled = permissionState[`${module}-${item}-${action}`];
          if (isEnabled) {
            const permKey = `IS_${item.toUpperCase()}_${action.toUpperCase()}`;
            permissionsObj[permKey] = true;
          }
        });
      });
    });
    
    const rolePayload = {
      roleName,
      permissions: JSON.stringify(permissionsObj),
      userId: (user && (user.id || user._id)) || loggedInUser.id
    };

    try {
      let response;
      
      if (roleData && roleData.id) {
        response = await accountService.updateRole(roleData.id, rolePayload);
      } else {
        response = await accountService.roles(rolePayload);
      }

      console.log('Role saved successfully:', response);
      
      alertService.success(roleData ? 'Role updated successfully' : 'Role created successfully');
      
      if (onSave && typeof onSave === 'function') {
        onSave(rolePayload);
      }
      
      handleClose();
    } catch (err) {
      console.error('Error saving role:', err);
      // const errorMessage = err.response && err.response.data && err.response.data.message ? 
      //   err.response.data.message : 
      //   'Failed to save role. Please try again.';
      // setError(errorMessage);
      // alertService.error('Failed to save role: ' + errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isChecked = (module, item, action) => {
    return !!permissionState[`${module}-${item}-${action}`];
  };
  console.log(roleName);
  return (
    <div 
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', 
        backdropFilter: 'blur(4px)',
        zIndex: 9999,
        overflowY: 'auto',
        paddingTop: 0,
        paddingBottom:  0
      }}
      className="custom-modal-wrapper"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          handleClose();
        }
      }}
    
    >
      <div 
        style={{ 
          backgroundColor: 'white', 
          borderRadius: '12px', 
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          width: '95%',
          maxWidth: '1000px',
          maxHeight: '85vh',
          overflowY: 'auto',
          padding: 0,
          animation: 'fadeIn 0.3s ease-out'
        }}
      >
        <div style={{
          background: '#f8fafc',
          borderBottom: '1px solid #e2e8f0',
          padding:'16px 24px',
          borderRadius: '12px 12px 0 0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h2 style={{ 
            fontSize: '20px',
            color: '#334155', 
            fontWeight: '600',
            margin: 0
          }}>
            {roleData ? `Edit Role: ${roleData.roleName}` : 'Add New Role and Permissions'}
          </h2>
          <button 
            type="button"
            onClick={handleClose}
            aria-label="Close"
            id="addRolePermissionCloseBtn"
            style={{ 
              background: '#f1f5f9',
              color: '#64748b',
              width: '36px',
              height: '36px',
              borderRadius: '6px',
              border: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '24px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.2s',
              zIndex: 1000
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#e2e8f0';
              e.currentTarget.style.color = '#334155';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = '#f1f5f9';
              e.currentTarget.style.color = '#64748b';
            }}
          >
            ×
          </button>
        </div>

        {/* Content Area */}
        <div style={{ padding:  '30px' }}>
          {/* Error message */}
          {error && (
            <div style={{
              backgroundColor: '#fee2e2',
              color: '#b91c1c',
              padding: '12px',
              borderRadius: '6px',
              marginBottom: '16px'
            }}>
              {error}
            </div>
          )}
          
          {/* Role Name Input with Nice Styling */}
          <div style={{
            marginBottom: '24px'
          }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              marginBottom: '8px',
              color: '#475569'
            }}>
              Role Name*
            </label>
            <div style={{ position: 'relative' }}>
              <input 
                type="text"
                placeholder="Enter role name"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  fontSize: '15px',
                  borderRadius: '6px',
                  border: '1px solid #cbd5e1',
                  outline: 'none',
                  transition: 'all 0.2s'
                }}
              />
            </div>
          </div>

          {/* Permissions Section with Tabs for Mobile and Side-by-Side for Desktop */}
          <div className="permissions-container">
            {/* Mobile Tab Selector (visible only on small screens) */}

            {/* Permissions Tables - Side by Side on Desktop, Tabbed on Mobile */}
            <div style={{ 
              display: 'flex', 
              flexDirection:  'row', 
              gap: '24px',
              flexWrap: 'wrap'
            }}>
              {Object.entries(permissions).map(([module, items]) => (
                <div 
                  key={module} 
                  style={{
                    flex: 1,
                    minWidth: '300px',
                    border: '1px solid #e2e8f0',
                    borderRadius: '6px',
                    overflow: 'hidden',
                    marginBottom: '16px',
                    display:  'block'
                  }}
                >
                  {/* Module Header */}
                  <div style={{
                    backgroundColor: '#f1f5f9',
                    color: '#334155',
                    padding: '10px 12px',
                    borderBottom: '1px solid #e2e8f0',
                    fontWeight: '600',
                    fontSize:'16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '8px',
                    marginBottom: '0'
                  }}>
                    <span>
                     {module}
                    </span>
          
                  </div>

                  <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                    <table style={{ 
                      width: '100%', 
                      borderCollapse: 'collapse',
                      minWidth: 'unset'
                    }}>
                      <thead>
                        <tr style={{ 
                          borderBottom: '1px solid #e2e8f0', 
                          fontWeight: 'bold'
                        }}>
                          <th style={{ 
                            padding: '10px 8px', 
                            textAlign: 'left',
                            fontSize: '14px',
                            width: '40%',
                            color: '#475569'
                          }}>
                            Permission
                          </th>
                          {actions.map((action) => (
                            <th 
                              key={action} 
                              style={{ 
                                padding: '10px 5px',
                                textAlign: 'center',
                                fontSize:'14px',
                                color: '#475569',
                                width: 'auto'
                              }}
                            >
                              {action}
                            </th>
                          ))}
                          {
                            <th style={{ 
                              width: '80px', 
                              padding: '10px 5px' 
                            }}></th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item) => (
                          <tr 
                            key={item} 
                            style={{
                              borderBottom: '1px solid #f1f5f9',
                              transition: 'all 0.2s'
                            }}
                          >
                            <td style={{ 
                              padding:'10px 8px',
                              fontWeight: '500',
                              fontSize:'14px',
                              color: '#334155',
                              whiteSpace: 'nowrap'
                            }}>
                              {item}
                       \
                            </td>
                            {actions.map((action) => (
                              <td 
                                key={action} 
                                style={{ 
                                  textAlign: 'center',
                                  padding:'8px'
                                }}
                              >
                                <CustomCheckbox
                                  checked={isChecked(module, item, action)}
                                  onChange={() => handleCheckboxChange(module, item, action)}
                                  size={ 32}
                                />
                              </td>
                            ))}
                          
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Save Button - Stack on mobile, row on desktop */}
          <div className="footer-btn-holder">
                <button
                  onClick={handleClose}
                  className="btn-custom-cancel"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSave}
                  disabled={isSubmitting}
                  className="btn-custom-primary"
                >
                  {isSubmitting ? (
                  <>
                <div className="subscription-loading-spinner"></div>
                Updating...
                 </>
                  ) : (
              <>
                Save
              </>
            )}
                </button>
              </div>
        </div>
      </div>

    </div>
  );
};

export default AddRolePermissionPopup;